<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded"><span class="epub-i">In memory of my mother,</span></p>
<p class="ded"><span class="epub-i">Gean O’Hara Britt,</span></p>
<p class="ded-b"><span class="epub-i">who loved to eat in tea rooms</span></p>
<p class="img-ns"><img alt="image" height="73" src="images/pgv.jpg" width="103"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7e104331